import { TotemSelect } from 'components/TotemSelect';

import styled from 'styled-components';

import { GetAllProductsQuery } from 'data/__generated__';

export const ProductSelector = ({
    label,
    products,
    productSelectedId,
    onProductSelection,
}: {
    label: string;
    products: GetAllProductsQuery['getAllProducts'];
    productSelectedId: string | null;
    onProductSelection: (productId: string) => void;
}) => {
    const productsOptions =
        products
            .map(({ _id, fullname }) => ({
                value: _id,
                label: fullname,
            }))
            .sort((a, b) => a.label.localeCompare(b.label)) || [];

    function onSelect(value: string | null) {
        if (!value) {
            return;
        }

        onProductSelection(value);
    }

    // Todo use react virtualized or react window with select. Because there are too much products
    return (
        <Container>
            <SelectContainer>
                <TotemSelect
                    label={label}
                    placeholder="Sélectionner un produit (recherche par nom ou par _id)"
                    value={productSelectedId}
                    options={productsOptions}
                    onChange={onSelect}
                />
            </SelectContainer>
        </Container>
    );
};

const Container = styled.span`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: 100%;
`;

const SelectContainer = styled.div`
    flex-grow: 1;
`;
